<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-cookie-consent"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-head-title">{{ lbl.cookie.title }}</div>
                </div>
                <div class="modal-base-body">
                    <div class="modal-body-txt" v-html="cookieContent"></div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-wrapper btn-cancel" @click="clickCancel()"> 
                        <div class="btn-txt">{{ lbl.default.close }}</div>  
                    </div>
                    <div class="btn-wrapper" @click="clickOk()">
                        <div class="btn-txt">{{ lbl.cookie.btn_consent }}</div>      
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
//service
import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";
//helper
import Account from '@/helper/AccountHelper.js';
/**
 * @property {CookieConsentModalController} controller (required) /components/Modal/Controller/CookieConsentModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "CookieConsentModal",
    props: {
        // busModal: Object,
        theme: String,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            tag: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),

            cookieContent: null,
            currentVersion: null,
            userConsent: null,

            token: Account.getToken(),
        };
    },
    created: function() {
        this.checkConsentCookie();
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        checkConsentCookie: async function  () {
            let currentVersion = await this.getCurrentVersion()
            if (currentVersion == null) {
                return
            }

            let userConsent = await this.getUserConsent(this.token)
            if (userConsent == null) {
                return
            }

            this.currentVersion = currentVersion.data.cookie.current_version;
            this.userConsent = userConsent;

            await this.getCookieContent(this.currentVersion)
        },
        getCurrentVersion: function () {
            return new Promise((resolve) => {
                PDPAService.apiGetPDPAVersion().then((data) => {
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error);
                    resolve(null)
                });
            })
        },
        getUserConsent: function(token) {
            return new Promise((resolve) => {
                PDPAService.apiGetUserPDPA(token).then((res) => {
                    resolve(res.data);
                }).catch((error) => {
                    this.errorApi(error);
                    resolve(null);
                });
            })
        },
        getCookieContent: function (version) {
            return new Promise((resolve) => {
                PDPAService.apiGetCookieContent("cookies", version, this.lblCode).then((res) => {
                    this.cookieContent = res.data
                    console.log(res);
                    resolve(res);
                })
                .catch((error) => {
                    console.log(error);
                    resolve(null);
                });
            })
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        clickOk: async function  () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }

            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    @import "@/style/base/base.scss";
    .modal-cookie-consent {
        @extend %modal-base;

        .modal-dialog {
            max-width: 380px;
            padding: 20px 0;

            @media(max-width: 390px){
                padding: 20px;
            }
        }

        .modal-body {
            padding: 10px 16px 24px 16px;
        }

        .modal-base-head {
            .modal-head-title {
                color: $green-00987F;
                font-size: 1.75rem;
                font-family: $semi_bold;
                margin-bottom: 20px;
                text-align: center;
                line-height: normal;
            }
        }

        .modal-base-body {

            max-height: 70vh;
            overflow-y: scroll;
            padding-right: 10px;

            &::-webkit-scrollbar {
                width: 4px;
                background: $a-gray-F1F1F1;
            }

            /* Handle */
            &::-webkit-scrollbar-thumb {
                border-radius: 40px;
                background: $orange1;
            }

            .modal-body-txt {
                color: $a-gray-575757;
                font-size: 1.5rem;
                font-family: $regular;
                line-height: normal !important;
                text-align: left !important;

                ol li {
                    font-family: $semi_bold;
                }

                a {
                    color: $a-gray-575757;
                    text-decoration: underline;
                }
            }
        }

        .modal-base-footer {
            margin-top: 16px;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
        }
    }
</style>
